import { useStoreState } from "../store/useStore";
import useFetch from "../../hooks/useFetch";

const useAction = (base?: string) => {
  const { baseUrl } = useStoreState();

  const { post } = useFetch(base ? base : baseUrl);

  const fetchJourneyUserInfo = async <T>() => {
    return post<T>(`uapi/v1/journey/user/info`);
  };

  return {
    fetchJourneyUserInfo
  };
};

export default useAction;
